<template>
  <select class="custom-select" v-model="selected" @change="$emit('changeSelected', $event.target.value)">
    <option v-for="(option, key) in options" :value="key">{{translateIfOptionString(option)}}</option>
  </select>
</template>

<script>
  export default {
    name: 'DropdownFilter',
    props: {
      options: Object,
    },
    data() {
      return {
        selected: 'all',
      };
    },
    methods: {
      translateIfOptionString(option) {
        return typeof option === 'string' ? this.I18n.t(option) : option;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/dropdown_filter.vue?3c7e3029